import { NavLink, useLocation, useParams } from "react-router-dom";

export const NavbarItem = ({ link, icon, label }) => {
  const params = useParams();
  const { pathname } = useLocation();

  /**
   * Workaround for adding .text-light class in dynamic routes since isActive param provided by
   * NavLink component is false for dynamic, not neseted routes like "/requests/:key"
   */

  let isActiveParamsPath = pathname === link;

  if (Object.keys(params).length > 0) {
    isActiveParamsPath =
      pathname ===
      link.split("/").slice(0, -1).join("/") + "/" + Object.values(params)[0];
  }

  return (
    <NavLink
      to={link}
      className={({ isActive }) =>
        `${isActive || isActiveParamsPath ? "text-light" : ""} nav-item`
      }
    >
      {icon}
      {label}
    </NavLink>
  );
};
